var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#e0f0e1",
    cx: 16,
    cy: 16,
    r: 15.87
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d5e2d5",
    d: "M16,.25A15.75,15.75,0,1,1,.25,16,15.77,15.77,0,0,1,16,.25M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86a94e",
    d: "M20.11,11.29l-.75.79-5.19,5.51L12.61,16l-.76-.76L10.31,16.8l.77.77,2.35,2.35.79.79.76-.82,6-6.32.75-.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8ea440029799f166c0c41a01ab3e6db1.svg";
export { ForwardRef as ReactComponent };